<script setup lang="ts">
import {computed, ref, watch} from "vue";
import axios from "axios";
import moment from "moment";

const props = defineProps({
    theme: Object,
    form: Object,
    startTime: String,
    endTime: String,
    selectedRentalItem: Object
})

const priceOfItem = ref(0);

const usedAdditionalCosts = computed(() => {
    const selectedAdditionalCosts = props.form.additional_costs;
    return props.selectedRentalItem?.additional_costs.filter(el => {
        return selectedAdditionalCosts.includes(el.id);
    });
})

watch(() => props.endTime, () => computePriceByTimeslots())

const computePriceByTimeslots = () => {
    if (props.form.id_rental_items) {

        axios.post('/api/rental/compute-price', {
            rental_item_id: props.form.id_rental_items,
            day: moment(props.form.day)?.format('YYYY-MM-DD'),
            start_time: props.startTime,
            end_time: props.endTime,
        }).then(res => { priceOfItem.value = res.data.price; });
    }
}

const resultPrice = computed(() => {
    let price = 0;
    let priceWithoutVat = 0;

    usedAdditionalCosts.value?.forEach(el => {
       price += Number(el?.unit_price);
       priceWithoutVat += Number(el?.unit_price) / (1 + Number(el?.vat_percentage) / 100);
    })

    price += priceOfItem.value;

    return {
        price_with_vat: Intl.NumberFormat('cs-CZ', {
            style: 'currency',
            currency: 'CZK',
        }).format(price),
        price_without_vat: Intl.NumberFormat('cs-CZ', {
            style: 'currency',
            currency: 'CZK',
        }).format(priceWithoutVat),
        has_vat: price !== priceWithoutVat,
    }
})
</script>

<template>
    <div class="flex flex-col items-end justify-center mr-2">
        <p class="text-lg font-semibold">{{resultPrice.price_with_vat}}</p>
        <p v-if="resultPrice.has_vat" class="opacity-50 text-sm -mt-1">{{resultPrice.price_without_vat}} bez DPH</p>
    </div>
</template>

<style scoped lang="scss">

</style>
